(function () {
  function init() {
    const modal = document.getElementById('dimensions-image-modal');
    if (!modal || modal.dataset.dimensionsInitialized) return;
    modal.dataset.dimensionsInitialized = 'true';

    const img = modal.querySelector('.dimensions-image-modal__img');
    let previouslyFocused = null;

    // Set image src and open via existing modal.js handler
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-dimensions-trigger]');
      if (!trigger) return;
      const url = trigger.dataset.dimensionsImageUrl;
      if (!url) return;
      previouslyFocused = trigger;
      if (img) {
        img.src = url;
        img.alt = trigger.dataset.dimensionsImageAlt || '';
      }
      if (window.modalHandler) window.modalHandler.showModal(modal);
    });

    // Restore focus to the triggering element when modal.js closes the modal
    new MutationObserver(() => {
      if (modal.style.display === 'none' || modal.style.display === '') {
        if (previouslyFocused && typeof previouslyFocused.focus === 'function') {
          previouslyFocused.focus();
          previouslyFocused = null;
        }
      }
    }).observe(modal, { attributes: true, attributeFilter: ['style'] });

    // Focus trap while modal is open
    modal.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab' || modal.style.display === 'none') return;
      const focusable = Array.from(
        modal.querySelectorAll('button:not([disabled]), [href], [tabindex]:not([tabindex="-1"])')
      );
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    // PDP variant change — update PDP block link and compare table current-column link
    document.addEventListener('change', (e) => {
      if (e.target.id !== 'product-select') return;
      const variantId = String(e.target.value || '').trim();
      if (!variantId) return;

      // Read pre-loaded variant→URL map from the first PDP dimensions block
      let variantData = null;
      const dataEl = document.querySelector('[data-dimensions-link-block] .pdp-dimensions-link__data');
      if (dataEl) {
        try { variantData = JSON.parse(dataEl.textContent.trim()); } catch { /* ignore */ }
      }

      // Update all PDP dimensions blocks
      document.querySelectorAll('[data-dimensions-link-block]').forEach((block) => {
        const blockDataEl = block.querySelector('.pdp-dimensions-link__data');
        if (!blockDataEl) return;
        let data = variantData;
        if (!data) { try { data = JSON.parse(blockDataEl.textContent.trim()); } catch { return; } }
        const url = data[variantId] || '';
        const wrapper = block.querySelector('[data-dimensions-link-wrapper]');
        const trigger = block.querySelector('[data-dimensions-trigger]');
        if (!wrapper || !trigger) return;
        if (url) {
          wrapper.removeAttribute('hidden');
          trigger.dataset.dimensionsImageUrl = url;
        } else {
          wrapper.setAttribute('hidden', '');
          trigger.dataset.dimensionsImageUrl = '';
        }
      });

      // Update compare table current-column link from the same pre-loaded data
      if (variantData) {
        const url = variantData[variantId] || '';
        const compareLink = document.querySelector(
          '.compare-table__heading--current .compare-table__dimensions-link'
        );
        if (compareLink) {
          if (url) {
            compareLink.removeAttribute('hidden');
            compareLink.dataset.dimensionsImageUrl = url;
          } else {
            compareLink.setAttribute('hidden', '');
            compareLink.dataset.dimensionsImageUrl = '';
          }
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
